import { isVue2 } from "vue-demi";
import { computed, getCurrentInstance } from "vue";
const useListeners = (eventsToDelete = []) => {
  const v2Listeners = computed(() => {
    var _a;
    let listeners = {};
    if (isVue2) {
      const vm = getCurrentInstance();
      listeners = { ...(_a = vm == null ? void 0 : vm.proxy) == null ? void 0 : _a.$listeners };
      if (eventsToDelete.length >= 1) {
        eventsToDelete.forEach((event) => delete listeners[event]);
      }
    }
    return listeners;
  });
  return { v2Listeners };
};
export {
  useListeners as u
};
